import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { isTokenExpired } from '../../share/utility'
import { UNREADY } from '../../utils/UIConstant'

const createAuthStateAtom = function () {
  const safeUsersStorage = {
    getItem: (key, _ignore_initialValue) => {
      try {
        const raw = localStorage.getItem(key)
        if (!raw || raw === 'null') return null

        const parsed = JSON.parse(raw)

        // ✅ validation：必须是 object
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
          console.warn('[usersAtom] invalid storage value, reset')
          return null
        }

        // ✅ Check if token is expired (for auth data)
        if (key === 'auth' && parsed.token) {
          if (isTokenExpired(parsed.token)) {
            console.warn('[authAtom] token expired, reset')
            return null
          }
        }

        return parsed
      } catch (e) {
        console.warn('[usersAtom] failed to parse storage, reset', e)
        return null
      }
    },

    setItem: (key, value) => {
      localStorage.setItem(key, JSON.stringify(value))
    },

    removeItem: (key) => {
      localStorage.removeItem(key)
    },
  }

  const authDataAtom = atomWithStorage('auth', UNREADY, safeUsersStorage)

  // A quick way to get auth user, don't use it as user since the information may be out of date
  const authUserAtom = atom((get) => get(authDataAtom)?.user || null)

  const isAuthenticatedAtom = atom((get) => !!get(authDataAtom)?.token)

  return {
    authData: authDataAtom,
    authUser: authUserAtom,
    isAuthenticated: isAuthenticatedAtom,
  }
}

const AuthStateAtom = createAuthStateAtom()
export default AuthStateAtom
export const authDataAtom = AuthStateAtom.authData
export const authUserAtom = AuthStateAtom.authUser
export const isAuthenticatedAtom = AuthStateAtom.isAuthenticated
